var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Customers',"subtitle":'Corporate - Add new customer'}}),_c('customer-corporate-form',{attrs:{"action":"add"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }